<template>
  <!-- Step 4 -->
  <div class="box mt-4">
    <div class="section-title">4. Submit Information</div>
    <som-collapse ref="collapse" :collapsed="collapsed">
      <div id="submit-information-content" class="form-content max-width-40">
        <div class="pt-4 pb-4 text-bold">OK2SAY is for serious reports only. Our operators will take action on tips submitted through this system. False tips will not be accepted and may be prosecuted.</div>
        
        <div v-if="submitResult.type" :class="{'mb-4': submitResult.type === 'error'}">
          <som-alert :type="submitResult.type" :headline="submitResult.message"></som-alert>
        </div>

        <div v-if="submitResult.type !== 'success'" class="d-flex justify-content-center">
          <som-button color="primary" v-on:click.prevent="submitData" :loading="processing">SUBMIT TIP</som-button>
        </div>
      </div>
    </som-collapse>
  </div>
</template>


<script>
export default {
  name: 'SubmitInformation',
  props: {
    collapsed: Boolean,
    showToggle: Boolean,
    toggle: Function,
    submit: Function,
  },
  data() {
    return {
      processing: false,
      submitResult: {
        type: null,
        message: '',
      }
    }
  },
  methods: {
    show() {
      this.$refs.collapse.show();
    },
    hide() {
      this.$refs.collapse.hide();
    },
    async submitData() {
      this.processing = true;

      const response = await this.submit();

      if (response && response.SubmitTipResult && !isNaN(response.SubmitTipResult)) {
        // Successful
        this.submitResult = {
          type: 'success',
          message: `Thank you. The tip was submitted successfully (reference number: ${response.SubmitTipResult}).`
        };
      } else {
        // Error
        this.submitResult = {
          type: 'error',
          message: response.SubmitTipResult
        };
      }

      this.processing = false;
    }
  },

  beforeDestroy() {
    this.observer.disconnect();
  },

  mounted() {
        // Select the node that will be observed for mutations
    var targetNode = document.getElementById('submit-information-content');

    // Options for the observer (which mutations to observe)
    var config = { attributes: true, childList: true, subtree: true };

    // Callback function to execute when mutations are observed
    const self = this;
    var callback = function() {
      self.$refs.collapse.refresh();
    };

    // Create an observer instance linked to the callback function
    this.observer = new MutationObserver(callback);

    // Start observing the target node for configured mutations
    this.observer.observe(targetNode, config);
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .selected-school-box {
    display: flex;
    flex-direction: 'row';
  }

  .selected-school-content {
    flex: 1;
  }

  .header-box {
    margin: 0 auto;
  }

  .logo-image {
    width: 100%;
    max-width: 16rem;
    height: auto;
  }

  .subtitle {
    font-size: 1.2rem;
  }
  @media screen and (max-width: 600px) {
    .subtitle {
      font-size: 1rem;
    }
  }

  .bold {
    font-weight: bold;
  }

  .box {
    background-color: white;
  }

  .max-width-30 {
    max-width: 30rem;
  }

  .max-width-40 {
    max-width: 40rem;
  }

  .form-content {
    padding: 2rem;
    padding-top: 0;
    margin: 0 auto;
  }

  .form-group {
    margin-bottom: 1rem;
  }

  .section-title {
    font-family: Montserrat,sans-serif;
    font-weight: 700;
    line-height: 1.1;
    font-size: 1.375rem;
    letter-spacing: .1px;
    padding: 1rem;
    margin: 0;
    color: rgb(52, 118, 163);
    white-space: nowrap; 
    overflow: hidden;
    text-overflow: ellipsis;
  }
  @media screen and (max-width: 600px) {
    .section-title {
      font-size: 1.2rem;
    }
  }

  .special-label {
    text-align: center;
    padding: 1rem;
    margin-bottom: 1rem;
    border-bottom: 1px solid rgb(236, 236, 236);
  }

  textarea {
    height: 8rem;
  }

  textarea,
  select,
  input {
    font-size: 0.875rem;
  }

  textarea::placeholder {
    color: #aaa;

  }

  .message {
    margin: 0 auto;
  }

  .align-center {
    margin: 0 auto;
  }

  .border-top {
    border-top: 1px solid rgb(29, 25, 25);
  }

  .border-top-light {
    border-top: 1px solid rgb(236, 236, 236);
  }

  .text-bold {
    font-weight: bold;
  }

  .enter-school-information-manually {
    margin-bottom: 1rem;
  }

  .label-optional {
    font-size: 0.6rem;
    color: rgb(110, 110, 110);
    margin-left: 0.25rem;
  }

  .radio-container {
    padding: 0.5rem 1rem;
  }

  .radio-container.is-invalid {
    border-radius: .25rem;
    border: 1px solid #b80000;
  }
</style>

<style>
</style>